<template>
    <button type="submit" class="bouton openSans font-bold white">
        <i class="fas fa-arrow-right"></i>
    </button>
</template>

<script>
export default {
    name: "Submit"
};
</script>

<style scoped lang="scss">
.bouton {
    width: 30%;
    padding: 20px;
    position: fixed;
    right: 0;
    bottom: 0;

    i {
        font-size: 2rem;
    }
}
.white {
    background-color: white;
    color: #4500b6;
}
</style>
